import { render, staticRenderFns } from "./ComplaintDetailCriterion.vue?vue&type=template&id=464cd7fb"
import script from "./ComplaintDetailCriterion.vue?vue&type=script&lang=js"
export * from "./ComplaintDetailCriterion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports